<template>
  <v-dialog v-model="show" width="1040">
    <v-card light>
      <v-card-title class="grey lighten-2" primary-title>{{
        title
      }}</v-card-title>

      <div class="print-content-outer">
        <div
          :key="index"
          class="page-outer"
          ref="page"
          v-for="(page, index) in pages"
        >
          <div
            :style="{
              backgroundImage: background && `url(${background})`,
              width: width + 'px',
              minHeight: minHeight + 'px',
            }"
            class="content"
          >
            <slot :page="page">
              <div
                :key="index"
                :style="field.style"
                class="field"
                v-for="(field, index) in fields"
              >
                {{ page[field.name] }}
              </div>
            </slot>
          </div>
        </div>
      </div>
      <v-divider light></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" flat light>戻る</v-btn>
        <v-btn @click="save" color="primary" flat light>Save as PDF</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import html2canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  props: [
    "title",
    "filename",
    "fields",
    "background",
    "pages",
    "orientation",
    "builder",
  ],
  data() {
    return {
      show: false,
    };
  },
  computed: {
    size() {
      return this.orientation !== "portrait"
        ? { x: 841.89, y: 595.28 }
        : { x: 595.28, y: 841.89 };
    },
    width() {
      return 1000;
    },
    minHeight() {
      return Math.floor((this.width / this.size.x) * this.size.y);
    },
  },
  methods: {
    async getImage(page) {
      let doc = page.children.length == 1 ? page.children[0] : page;

      let width = doc.clientWidth;
      let height = doc.clientHeight;
      var canvas = document.createElement("canvas");
      var scale = 2;
      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width * scale + "px";
      canvas.style.height = height * scale + "px";

      canvas.getContext("2d").scale(scale, scale);
      var opts = {
        allowTaint: true,
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: true, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height,
        ignoreElements: (e) => {
          return false;
        },
        useCORS: true, // 【重要】开启跨域配置
      };
      canvas = await html2canvas(doc, opts);
      var context = canvas.getContext("2d");
      // 【重要】关闭抗锯齿
      context.mozImageSmoothingEnabled = false;
      context.webkitImageSmoothingEnabled = false;
      context.msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;

      var imgWidth = this.size.x;
      var imgHeight = (imgWidth / width) * height;
      var pageData = canvas.toDataURL("image/jpeg", 0.9);
      var position = 0;
      canvas.remove();
      return {
        img: pageData,
        position: position,
        imgWidth: imgWidth,
        imgHeight: imgHeight,
      };
    },
    async getImages() {
      var result = [];

      for (var i = 0; i < this.$refs.page.length; i++) {
        var image = await this.getImage(this.$refs.page[i]);
        result.push(image);
      }
      return result;
      //return Promise.all(this.$refs.page.map(this.getImage));
    },
    defaultBuilder(pdf) {
      return this.getImages().then((pages) => {
        let images = pages;
        console.log(images);
        images.forEach((i, index) => {
          if (index > 0) pdf.addPage();
          pdf.addImage(i.img, "JPEG", 0, i.position, i.imgWidth, i.imgHeight);
        });
        return pdf;
      });
    },
    save() {
      if (this.builder) {
        this.builder().then(() => {
          this.$emit("print", this.pages);
        });
      } else {
        let pdf = new JsPDF(this.orientation || "landscape", "pt", "a4");
        this.defaultBuilder(pdf).then((pdf) => {
          var name = this.filename.split(".");
          pdf.save(name[0] + "_" + new Date().format("yyyyMMddhhmm") + ".pdf");
          this.$emit("print", this.pages);
        });
      }
    },
  },
};
</script>
<style scoped>
.page-outer {
  width: 1000px;
  box-sizing: content-box;
  padding: 0px;
  margin: 5px;
  box-shadow: 1px 1px 3px #999;
  position: relative;
  background-color: #fff;
}
.content {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
}
.field {
  position: absolute;
}
.print-content-outer {
  overflow-y: auto;
  max-height: 550px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
